import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeskOffice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDeskOffice"><Path d="M2.5 18.5V5.5H11.5M11.5 5.5H21.5V18.5H11.5V5.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 8.5V9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDeskOffice;
